import { BodyUtility } from '../../Components/AxUtility/BodyUtility';
import { AxInit, ModuleName } from '../../Lib/AxSystem/AxInit';
import { AxLoad } from '../../Lib/AxSystem/AxLoad';
import { AxPixelTracking } from '../AxMetaTracking/AxPixelTracking';
import { CartEntryQuantity } from './CartEntryQuantity';

@ModuleName("PopUpShoppingCart")
export class PopUpShoppingCart implements AxInit {

    private initData: PopUpShoppingCartInit;
    private axPixelTracking = new AxPixelTracking();

    constructor(
        protected _bodyUtility: BodyUtility = new BodyUtility(),
        protected _cartEntryQuantity = new CartEntryQuantity()
    ) { }

    AxInit(init: PopUpShoppingCartInit) {
        this.initData = init;
        $('.ax-nav-item-sc').filter(this.openLateralCart).on('click', (e) => {
            e.preventDefault();

            $('.pop-up-cart--container').removeClass('d-none');
            $('.pop-up-cart').removeClass('collapsed');
            $('.pop-up-cart--filler').removeClass('collapsed').show();
            this.loadPopUpShoppingCart();
        });

        $(document)
            .on('visibilitychange', () => AxLoad.ReloadModule('ShoppingCartReservationTimer'))
            .on('click', '.pop-up-cart--closeBtn, .pop-up-cart--filler', (e) => {
                e.preventDefault();
                $('.pop-up-cart, .pop-up-cart--filler').addClass('collapsed');
                setTimeout(() => $('.pop-up-cart--filler').hide(), 300);
                setTimeout(() => this.unloadPopUpShoppingCart(), 350);
            })
            .on('click', '.pop-up-cart--deleteItemBtn', (e) => {
                e.preventDefault();
                const cartEntryID = $(e.target).attr('data-position-id');
                const dataRelatedTicket = $(e.target).attr('data-related-tickets') ?? "";
                this.removeCartEntry(cartEntryID, dataRelatedTicket);
            })
            .on('click', '.pop-up-cart--giftCardRemove', (e) => {
                e.preventDefault();
                const cartEntryID = $(e.target).attr('data-position-id');
                this.removeCartEntry(cartEntryID, "");
            })
            .on('click', '#btnApplyPromoCode', (e) => {
                e.preventDefault();
                this.applyPromoCode();
            })
            .on('click', '.pop-up-cart--entryPromoCode', (e) => {
                e.preventDefault();
                let promocode = $(e.target).attr('data');
                this.unloadPopUpShoppingCart();
                AxessViewer.loadPartialView('/ShoppingCart/RemovePromoCode', { code: promocode }, () => this.loadPopUpShoppingCart(), {
                    reload: false,
                });
            })
            .on('click', '[data-popup-remove]', (e) => {
                e.preventDefault();
                let promocode = $(e.currentTarget).data('popup-remove');
                this.unloadPopUpShoppingCart();
                AxessViewer.loadPartialView('/ShoppingCart/RemovePromoCode', { code: promocode }, () => this.loadPopUpShoppingCart(), {
                    reload: false,
                });
            });

        $(() => {
            if (localStorage.getItem('reloadFlag') === 'true') {
                const $popUpCartFiller = $('.pop-up-cart--filler');
                const popUpShoppingCart = new PopUpShoppingCart();
                localStorage.removeItem('reloadFlag');
                $('.pop-up-cart').removeClass('collapsed');
                $popUpCartFiller.show();
                setTimeout(() => $popUpCartFiller.css('opacity', 0.7), 10);

                popUpShoppingCart.loadPopUpShoppingCart();
            }
        });

    }

    private loadPopUpShoppingCart() {
        const url = '/ShoppingCart/GetPopUpShoppingCart';
        $('html').css('top', 0).scrollTop(0);

        AxessViewer.loadPartialView(url, {}, (res) => {
            $('#popUpShoppingCart').html(res);
            this._bodyUtility?.DisableScroll();
            this._cartEntryQuantity.initQuantityCounters(
                this.deleteGropuedItems.bind(this),
                this.createGropuedItems.bind(this),
                this.initData.maxItems,
            );
            AxLoad.ReloadModule("ShoppingCartReservationTimer");
        }, {
            dataType: 'html',
        });
    }

    private unloadPopUpShoppingCart() {
        this._bodyUtility.EnableScroll();
        const $spinner = $('<div>', { class: 'ax-loading-spinner pop-up-cart--loader', style: `max-height: ${$(window).height()}px` });
        $('#popUpShoppingCart').html($spinner.prop('outerHTML'));

        $('.pop-up-cart--container').addClass('d-none');
    }

    private removeCartEntry(cartEntryID: string, relatedTickets: string) {
        this.unloadPopUpShoppingCart();
        const data = {
            targetPositionId: cartEntryID,
            relatedTickets: relatedTickets.split('+').filter(Boolean),
        };
        this.axPixelTracking.AxInit({ action: 'removeFromCart', positionId: data.targetPositionId });
        AxessViewer.loadPartialView('/ShoppingCart/RemoveFromCart', data, () => this.loadPopUpShoppingCart());
    }

    private applyPromoCode() {
        $('[data-promocode="result"]').remove();

        const giftCardSerialNr: string | number | string[] = $('#PromoCodePop').val();

        AxessViewer.loadPartialView('/ShoppingCart/CheckPromoCodes', {
            promoCodes: [giftCardSerialNr],
        }, (res: ICheckPromoCodeResult) => {
            if (res.success && res.discountFound) {
                if (res?.isPromocodeApplied == false) {
                    this.applyGiftCardEMoney(giftCardSerialNr, res);
                } else {
                    localStorage.setItem('reloadFlag', 'true');
                    location.reload();
                }
            } else if (res?.isPromocodeApplied === false) {
                this.applyGiftCardEMoney(giftCardSerialNr, res);
            }
        });
    }


    private getGiftCardSerialNr() {
        const promocode: string | number | string[] = $('#PromoCodePop').val();
        if (!promocode) {
            return;
        }
        return promocode;
    }

    private applyGiftCardEMoney(giftCard: string | number | string[], promoCodeResult: ICheckPromoCodeResult) {
        AxessViewer.loadPartialView('/GiftCards/ApplyGiftCardEMoney', {
            giftCard,
        }, (res) => {
            if (res.success) {
                localStorage.setItem('reloadFlag', 'true');
                location.reload();
            } else if (promoCodeResult.discountFound === false) {
                const errorLabel = $('<label></label>').addClass('field-error ax-pt-xs').attr('data-promocode', "result").html(promoCodeResult.errorMessage);
                $('[name=PromoCodPop] + label').after(errorLabel);

                setTimeout(() => {
                    $('[data-promocode="result"]').remove();
                }, 2500);
            }
        });
    }

    private openLateralCart() {
        return !window.location.href.contains('Payment') && !window.location.href.contains('ShoppingCart')
    }

    private deleteGropuedItems(cartEntryId: string, itemsToDelete: string[]) {
        this.unloadPopUpShoppingCart();
        const data = {
            targetPositionId: cartEntryId,
            relatedTickets: itemsToDelete,
        };
        AxessViewer.loadPartialView('/ShoppingCart/RemoveFromCart', data, () => this.loadPopUpShoppingCart());
    }

    private createGropuedItems(cartEntryId: string, itemsToAdd: number) {
        this.unloadPopUpShoppingCart();
        const data = {
            cartEntryId: cartEntryId,
            numberOfItemsToAdd: itemsToAdd,
        };
        AxessViewer.loadPartialView('/ShoppingCart/AddGroupedTicketToCart', data, () => this.loadPopUpShoppingCart());
    } 
}

interface ICheckPromoCodeResult {
    success: boolean;
    discountFound: false;
    promocodes: string[];
    isPromocodeApplied: boolean;
    errorMessage: string;
}

class PopUpShoppingCartInit {
    maxItems: number;
}